const fadeDuration = 150;
const copiedStateDuration = 2000;

const wait = (duration) => new Promise((resolve) => {
    window.setTimeout(resolve, duration);
});

const copyTextToClipboard = async (text) => {
    if (!(navigator.clipboard && typeof navigator.clipboard.writeText === 'function')) {
        throw new Error('Clipboard API unavailable');
    }

    await navigator.clipboard.writeText(text);
};

const resetCopiedState = (button) => {
    button.classList.remove('is-fading', 'is-copied');
};

const showCopiedState = async (button) => {
    button.classList.add('is-fading');
    await wait(fadeDuration);

    button.classList.remove('is-fading');
    button.classList.add('is-copied');

    await wait(copiedStateDuration);

    button.classList.add('is-fading');
    await wait(fadeDuration);

    resetCopiedState(button);
};

const SingleResource = () => {
    const citationItems = document.querySelectorAll('.copy_citation_item[data-text]');

    if (!citationItems.length) {
        return;
    }

    citationItems.forEach((button) => {
        button.addEventListener('click', async () => {
            const textToCopy = button.getAttribute('data-text');

            if (!textToCopy || button.dataset.copyPending === 'true') {
                return;
            }

            button.dataset.copyPending = 'true';

            try {
                await copyTextToClipboard(textToCopy);
                await showCopiedState(button);
            } catch (error) {
                resetCopiedState(button);
            } finally {
                delete button.dataset.copyPending;
            }
        });
    });
};

export default SingleResource;